import { memo, useMemo } from 'react'
import { Range } from 'react-date-range'
import { useLocation } from 'react-router-dom'

import { AUDITS, DASHBOARD, OPERATIONS } from '../../constants/paths'
import {
  AUDITOR_PATHS,
  cognitoGroups,
  MANAGER_PATHS,
  OPERATIONS_PATHS,
  SAVER_PATHS,
  WAREHOUSE_PATHS,
} from '../../constants/userPermissions'
import DatePicker from '../DatePicker'
import HubDropdown from '../HubDropdown'
import Tab from './components/Tab'
import { PAGE_INFO } from './constants'
import useStyles from './styles'
interface Props {
  currentHubId: string | null
  setCurrentHubId: (val: string) => void
  setCurrentDateRange: (range: Range[]) => void
  currentDateRange: Range[]
  userRole: string
}

const { admin, manager, operations, warehouse, auditor, saver } = cognitoGroups

function Header({
  currentHubId,
  setCurrentHubId,
  setCurrentDateRange,
  currentDateRange,
  userRole,
}: Props) {
  const location = useLocation()

  const pathname = useMemo(() => '/'.concat(location.pathname.split('/')[1]), [location.pathname])

  const isOperationPage = useMemo(() => pathname === OPERATIONS, [pathname])
  const isAuditPage = useMemo(() => pathname === AUDITS, [pathname])

  const classes = useStyles({})

  const currentPageInfo = useMemo(() => PAGE_INFO[pathname] || PAGE_INFO[DASHBOARD], [pathname])

  const pageTabs = useMemo(() => {
    if (currentPageInfo.hasTabs) {
      return Object.values(PAGE_INFO).filter(page => page.section === currentPageInfo.section)
    }
  }, [currentPageInfo])

  const pageTabsByRole = useMemo(() => {
    if (pageTabs?.length) {
      switch (userRole) {
        case admin:
          return pageTabs
        case manager:
          return pageTabs.filter(item => MANAGER_PATHS.includes(item.link))
        case operations:
          return pageTabs.filter(item => OPERATIONS_PATHS.includes(item.link))
        case warehouse:
          return pageTabs.filter(item => WAREHOUSE_PATHS.includes(item.link))
        case auditor:
          return pageTabs.filter(item => AUDITOR_PATHS.includes(item.link))
        case saver:
          return pageTabs.filter(item => SAVER_PATHS.includes(item.link))
        default:
          return pageTabs
      }
    }
  }, [pageTabs, userRole])

  return (
    <header className={classes.root}>
      <div className={classes.main}>
        <div className={classes.leftPart}>
          {currentPageInfo?.icon ? (
            <div className={classes.iconContainer}>{currentPageInfo.icon}</div>
          ) : null}
          {currentPageInfo?.section ? (
            <p className={classes.section}>{currentPageInfo?.section}</p>
          ) : null}
          {currentPageInfo?.title ? (
            <p className={classes.title}>{currentPageInfo?.title}</p>
          ) : null}
        </div>

        <div className={classes.rightPart}>
          {!isAuditPage ? (
            <>
              <DatePicker
                setCurrentDateRange={setCurrentDateRange}
                currentDateRange={currentDateRange}
                isOperationPage={isOperationPage}
              />

              {!isOperationPage ? (
                <HubDropdown currentHubId={currentHubId} setCurrentHubId={setCurrentHubId} />
              ) : null}
            </>
          ) : null}
        </div>
      </div>
      {pageTabsByRole?.length ? (
        <div className={classes.tabsContainer}>
          {pageTabsByRole.map(tab => (
            <Tab key={tab.link} tab={tab} />
          ))}
        </div>
      ) : null}
    </header>
  )
}

export default memo(Header)
